import React from 'react'

const BlogLogo = () => (
  <svg
    width='260'
    height='250'
    viewBox='0 0 741 567'
    fill='currentFill'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M439.963 62.9854C327.401 62.9854 235.797 154.718 235.797 267.504V270.44H314.942V267.504C314.942 198.44 371.019 142.268 439.963 142.268C508.908 142.268 564.984 198.44 564.984 267.504V270.44H644.129V267.504C644.129 154.718 552.555 62.9854 439.963 62.9854Z'
      fill='white'
    />
    <path
      d='M425.128 298.482C425.128 367.546 369.052 423.719 300.108 423.719C231.163 423.719 175.087 367.546 175.087 298.482V295.546H95.9414V298.482C95.9414 411.269 187.516 503.001 300.108 503.001C412.7 503.001 504.274 411.269 504.274 298.482V295.546H425.128V298.482Z'
      fill='white'
    />
    <path d='M175.087 31.5063H95.9414V270.439H175.087V31.5063Z' fill='white' />
    <path d='M644.13 295.546H564.984V534.479H644.13V295.546Z' fill='white' />
  </svg>
)

export default BlogLogo
